module.exports = __webpack_public_path__ + "static/MN-26aae69430b59cc7577b6ff607e809ed.svg";